import moment from "moment";
import "moment-timezone";

import type { InternationalTime } from "@busbud/int-schemas/udm";

import { DEFAULT_TIMEZONE } from "@app/constants/timezone";

export function isInFutureFromNow(time: InternationalTime): boolean {
  const now_time = {
    ...time,
    timestamp: moment().tz(time.timezone).toISOString(true)
  };

  return isInFutureFrom(time, now_time);
}

export function isInFutureFrom(
  time_1: InternationalTime,
  time_2: InternationalTime
): boolean {
  const time_1_m = moment(time_1.timestamp).tz(
    time_1.timezone || DEFAULT_TIMEZONE
  );
  const time_2_m = moment(time_2.timestamp).tz(
    time_2.timezone || DEFAULT_TIMEZONE
  );

  return time_1_m.isAfter(time_2_m);
}
